import { Etablissement } from '@teetsh/app/src/types/etablissement';

export function getEtablissementIdentifier(
  etablissement: Etablissement,
): string | undefined {
  if ('uai' in etablissement) {
    return etablissement.uai;
  }
  if ('district' in etablissement) {
    return etablissement.district;
  }
  return undefined;
}

export function getEtablissementCity(etablissement: Etablissement): string {
  if ('city' in etablissement) {
    return etablissement.city;
  }
  if ('suburb' in etablissement) {
    return etablissement.suburb;
  }
  return '';
}

export function getEtablissementPostalCode(
  etablissement: Etablissement,
): string {
  if ('postalCode' in etablissement) {
    return etablissement.postalCode;
  }
  if ('postcode' in etablissement) {
    return etablissement.postcode;
  }
  return '';
}

export function getEtablissementAddress(
  etablissement: Etablissement,
): string | undefined {
  if ('address' in etablissement) {
    return etablissement.address;
  }
  return undefined;
}
